import script from "./PedidoDetallesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PedidoDetallesModal.vue?vue&type=script&setup=true&lang=ts"

import "./PedidoDetallesModal.vue?vue&type=style&index=0&id=338ecad3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-338ecad3"]])

export default __exports__